import { HISTORY_FILTER_STATUS } from '@/app/stores/history-transaction/types';
import { Status } from '@/app/graphql/payment/sdk.payment';
import { computed } from 'vue';
import { SignRight, SignScheme } from '@/app/graphql/access-control/sdk.access-control';
import { useAuthUserStore } from '@/app/stores/user';

export function useFilterStatus() {
  const authUserStore = useAuthUserStore();
  const currentContract = computed(() => authUserStore.selectedUserContract);
  const isContractPayControl = computed(() => authUserStore.isContractPayControl);

  const valueForSing = () => {
    if (
      currentContract.value?.userContractAttributes &&
      [SignRight.Auditor, SignRight.Creator].includes(currentContract.value.userContractAttributes.signRight)
    ) {
      return isContractPayControl.value
        ? [Status.SecondSignInPayControlComplete, Status.FirstSignInPayControlComplete]
        : [Status.PartiallyConfirmed, Status.OnVerification];
    }

    return authUserStore.isSignNone
      ? isContractPayControl.value
        ? [Status.SecondSignInPayControlComplete]
        : [Status.PartiallyConfirmed]
      : isContractPayControl.value
        ? [Status.FirstSignInPayControlComplete]
        : [Status.OnVerification];
  };
  const valueForFailed = () => {
    return authUserStore.isFirstSign || isContractPayControl.value
      ? [Status.CanceledSignOne]
      : [Status.CanceledSignOne, Status.CanceledSignTwo];
  };
  const valueForFailedForSalary = () => {
    return currentContract.value?.signScheme === SignScheme.OneSignatory
      ? [Status.CanceledSignOne]
      : [Status.CanceledSignOne, Status.CanceledSignTwo];
  };

  const valueForErrorForSalary = () => {
    const statuses = [Status.Error, Status.TimeIsOut, Status.TimeoutCanceledSignOne];
    return currentContract.value?.signScheme === SignScheme.OneSignatory
      ? statuses
      : [...statuses, Status.TimeoutCanceledSignTwo];
  };

  const getStatusByKey = (value: HISTORY_FILTER_STATUS, isSalaryStatus: boolean = false): Status[] => {
    const statuses = {
      [HISTORY_FILTER_STATUS.ALL]: [],
      [HISTORY_FILTER_STATUS.FOR_SIGN]: valueForSing(),
      [HISTORY_FILTER_STATUS.FAILED]: !isSalaryStatus ? valueForFailed() : valueForFailedForSalary(),
      [HISTORY_FILTER_STATUS.FOR_EDITING]: [Status.ForEditing],
      [HISTORY_FILTER_STATUS.SUCCESS]: [Status.Success, Status.Kvit],
      [HISTORY_FILTER_STATUS.ERROR]: !isSalaryStatus ? [Status.Error, Status.TimeIsOut] : valueForErrorForSalary(),
      [HISTORY_FILTER_STATUS.DRAFT]: [Status.Draft],
    };

    return statuses[value] ?? [];
  };

  return {
    getStatusByKey,
  };
}
